import {DialogActions, DialogContent, Typography} from '@mui/material';

import useReportViews from '../../../../hooks/providers/useReportViews';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const DeleteViewModal = () => {
  const {deleteView, viewToDelete, setViewToDelete, isDeleteViewModalOpen, setIsDeleteViewModalOpen} = useReportViews();

  const onClose = () => {
    setIsDeleteViewModalOpen(false);
    setViewToDelete(null);
  };

  const handleDelete = () => {
    deleteView(viewToDelete);
    onClose();
  };

  if (!isDeleteViewModalOpen) return null;

  return (
    <BaseModal canCloseOnBackdropClick={false} hasCloseIcon onClose={onClose} open title="Sauvegarder une vue">
      <DialogContent sx={{p: 3}}>
        <Typography fontSize={16} lineHeight={1.5}>
          Vous êtes sur le point de supprimer la vue <b>{viewToDelete.report_state_name}</b>.
          <br /> Cette action est irréversible.
        </Typography>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', mb: 2}}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          Supprimer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default DeleteViewModal;
